define(["exports", "styled-components", "../../themes"], function (_exports, _styledComponents, _themes) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _styledComponents = _interopRequireDefault(_styledComponents);

  var Wrapper = _styledComponents.default.div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-9xqrxb-0"
  })([".vg-editor-wrapper{border-radius:5px;font-size:13px;line-height:1.5;font-family:Arial,Helvetica,sans-serif;.vg-editor-toolbar{background-color:", ";border:0;border-radius:5px 5px 0 0;margin-bottom:0;padding:7px 5px 3px;.rdw-option-wrapper{border:1px solid ", ";border-radius:4px;&:last-of-type{margin-right:0;}}.rdw-dropdown-wrapper{border:1px solid ", ";border-radius:4px;padding:0 5px;.rdw-dropdown-optionwrapper{border-radius:4px;li{padding:5px 10px;text-align:left;}}}}.vg-editor{border:0;max-height:250px;min-height:200px;overflow:auto;padding:0 10px;&:focus-within{", ";}}}.rdw-dropdown-wrapper{position:relative;.rdw-dropdown-custom{position:absolute;right:0;width:150px;.rdw-dropdownoption-default{padding:0 !important;&:hover{background:", ";}a{color:", ";font-size:13px;padding:8px 10px;text-decoration:none;text-transform:none;width:100%;outline:none;&:focus,&:hover{background:", ";}}}}}.rdw-dropdown-select-variable{position:relative;height:30px;display:flex;align-content:center;span{padding:6px;}}"], function (_ref) {
    var theme = _ref.theme;
    return theme.colors.lightGray;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.lightGray;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.lightGray;
  }, _themes.focusBoxShadow, function (_ref4) {
    var theme = _ref4.theme;
    return theme.colors.lightGray;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.colors.dark;
  }, function (_ref6) {
    var theme = _ref6.theme;
    return theme.colors.lightGray;
  });

  var _default = Wrapper;
  _exports.default = _default;
});